<template>
  <div class="grid-view">
    <div class="main-content order-grid">
      <search-item
        :key="identify"
        :ref="identify"
        :show-more-scheme="true"
        :show-simple="showSimple"
        :expand-adv="false"
        :search-item-code="searchItemCode"
        :config-module="configModule"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="simQueryPlaceholder"
        :is-append-query="isAppendQuery"
        :col-settings="colSettings"
        @advSearchItemCallBack="fetchData"
        @simSearchItemCallBack="fetchDataBykeyWord"
      >
        <template slot="operations">
          <slot name="operations" />
        </template>
        <template slot="searchAreaHeader">
          <slot name="searchAreaHeader" />
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="gridConfigModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div id="footer-wrapper-order-grid" class="pagination-wrapper">
        <cargo-pagination
          ref="paginationOrderGrid"
          :config-module="gridConfigModule"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getGridSelected } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import StrUtils from '@/utils/StrUtils'
import { queryFbaJobList } from '@/api/Fba/fbaJob'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { getFilterCacheList } from '@/utils/basicDataCache'

export default {
  name: 'OrderGrid',
  components: { searchItem },
  props: {
    identify: { type: String, default: 'orderGrid' }, // ID
    viewSource: { type: String, default: 'fbaOrder' }, // 引用页面: fbaVerify=订单审核
    configModule: { type: String, default: '101' }, // 高级查询条件 下单 101 审核 102
    gridConfigModule: { type: String, default: '1909034' }, // 列表设置
    showSimple: { type: Boolean, default: true },
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    colSettings: { type: Object, default: () => { return { span: 6 } } }
  },
  data() {
    return {
      loading: false,
      // customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      isPretrialReview: false, // 复核参数
      searchItemCode: '按FBA查询',
      simQueryPlaceholder: this.$t('Clearing.QuickRetrieval') + this.$t('Warehouse.CommissionNo'),
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('FbaJob.ShipmentId'), field: 'shipmentId', width: 140 },
        { headerName: this.$t('FbaJob.BookingNo'), field: 'bookingNo', width: 140 },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 140,
          valueFormatter: (params) => {
            const verifyState = params.data.verifyState || 0
            return ((!this.isPretrialReview && verifyState === Number(FbaJobConstants.VERIFY_STATE_APPROVED.code)) || (this.isPretrialReview && verifyState === Number(FbaJobConstants.VERIFY_STATE_REVIEWED.code))) ? params.value : ''
          } },
        { headerName: this.$t('FbaJob.CustomerId'), field: 'customerId', width: 200,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          }
        },
        { headerName: this.$t('FbaJob.DomesticWarehouse'), field: 'domesticWarehouse', width: 120,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_10') : ''
          } },
        { headerName: this.$t('FbaJob.AmazonWarehouseCode'), field: 'warehouseCode', width: 140 },
        { headerName: this.$t('FbaJob.ServiceChannel'), field: 'serviceChannel', width: 140 },
        { headerName: this.$t('FbaJob.ReferenceId'), field: 'referenceId', width: 140 },
        { headerName: this.$t('FbaJob.ShippingType'), field: 'shippingType', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.shippingTypeLabelFunc(params.value)
          } },
        { headerName: this.$t('FbaJob.LoadingPortCode'), field: 'loadingPortCode', width: 170,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        },
        { headerName: this.$t('FbaJob.IncoTerm'), field: 'incoTerm', width: 120 },
        { headerName: this.$t('FbaJob.PoNumber'), field: 'poNumber', width: 120 },
        { headerName: this.$t('FbaJob.ContainerLoadType'), field: 'containerLoadType', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          } },
        { headerName: this.$t('FbaJob.Op'), field: 'op', width: 120,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          } },
        { headerName: this.$t('FbaJob.Sales'), field: 'sales', width: 120,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          } },
        { headerName: this.$t('FbaJob.Csr'), field: 'csr', width: 120,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_csr')
          } },
        { headerName: this.$t('FbaJob.Dc'), field: 'dc', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('FbaJob.PickupService'), field: 'pickupService', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          } },
        { headerName: this.$t('FbaJob.Packing'), field: 'packing', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', params.value, 'chineseName')
          } },
        { headerName: this.$t('FbaJob.ValueAddedServices'), field: 'valueAddedServices', width: 120 },
        { headerName: this.$t('FbaJob.RemoteWarehouse'), field: 'remoteWarehouse', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          } },
        { headerName: this.$t('FbaJob.PreAmazonWhTime'), field: 'preAmazonWhTime', width: 150 },
        { headerName: this.$t('FbaJob.PreWarehousingTime'), field: 'preWarehousingTime', width: 120 },
        { headerName: this.$t('FbaJob.VerifyRefuseReason'), field: 'verifyRefuseReason', hide: true, width: 150 },
        { headerName: this.$t('FbaJob.ReverifyRefuseReason'), field: 'reverifyRefuseReason', hide: true, width: 150 },
        { headerName: this.$t('FbaJob.ChargingMethod'), field: 'chargingMethod', width: 120,
          cellRenderer: (params) => {
            if (!params.value) return
            return Number(params.value) ? 'CBM' : 'KG'
          } },
        { headerName: this.$t('FbaJob.QuantityContract'), field: 'quantityContract', width: 120,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return this.$numeral(params.value).format('0')
          } },
        {
          headerName: this.$t('FbaJob.WeightContract'), field: 'weightContract', width: 120,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return this.$numeral(params.value).format('0.00')
          } },
        { headerName: this.$t('FbaJob.CubageContract'), field: 'cubageContract', width: 120,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return this.$numeral(params.value).format('0.000')
          } },
        { headerName: this.$t('FbaJob.VerifyState'), field: 'verifyState', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.verifyStateLabelFunc(params.value)
          } },
        { headerName: this.$t('SeaExport.Auditor'), field: 'verifyBy', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('SeaExport.FcAuditDate'), field: 'verifyDate', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('FbaJob.SubmitState'), field: 'submitState', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.submitStateLabelFunc(params.value)
          } },
        { headerName: this.$t('FbaJob.SubmitBy'), field: 'submitBy', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('FbaJob.SubmitDate'), field: 'submitDate', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('FbaJob.CreatedBy'), field: 'createdBy', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FbaJob.DateCreated'), field: 'dateCreated', width: 140 }
      ],
      rowData: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 50,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: []
      },
      selectedItem: {}, // 表格选中项
      queryOfficeId: 0, // 记录查询时的分公司Id
      isZY: false
    }
  },
  computed: {
    isOrder() { // 下单
      return this.viewSource === 'fbaOrder'
    },
    isVerify() { // 审核
      return this.viewSource === 'fbaVerify'
    },
    customSearchItems() { // 自定义高级查询项
      return this.getCustomSearchItems()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initConfig()
    this.toQueryList(true)
    await this.initColumnDefs()
  },
  methods: {
    // 配置参数
    initConfig() {
      this.isPretrialReview = Number(cache.config.get('PretrialReviewFBA')) === 1
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
    },
    // 查询
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      // 高级查询条件组装
      if (!simpleTriggerMode) {

      }
      if (this.viewSource === 'fbaVerify') {
        // 订单已提交 = 2【该逻辑已转移到后端】
        // const option = new AdvancedSearchOption(null, 'fbaJob.SUBMIT_STATE', 2, OperatorConstants.OPERATOR_EQUAL.code)
        // finallyConditions.push(option.formatObj2Json())
      }
      finallyConditions.push(...conditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'fbaJob.BOOKING_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        this.fetchData(conditions, true)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryList()
    },
    toQueryList(defaultSearch = false) {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, requires, pageNum, pageSize } = this.searchConditions
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, 'requestSource': this.viewSource, 'defaultSearch': defaultSearch }
      this.loading = getLoading()
      queryFbaJobList(requestBody).then(res => {
        const results = res.data.list
        this.rowData = results
        this.searchConditions.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      const result = this.getSelections()
      // 拒绝按钮禁用/启用
      let status = true
      let reviewState = true
      result.forEach(item => {
        // if(item.jobState !== 2 && item.verifyState !== 0){
        if (item.verifyState === 0) {
          status = false
          return
        } else if (item.verifyState === 1) {
          // 复核通过/复核拒绝按钮是否禁用
          reviewState = false
          return
        }
      })
      this.$emit('refusePermission', status)
      this.$emit('reviewRefusePermission', reviewState)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
      const result = this.getSelections()
      // 拒绝按钮禁用/启用
      let status = true
      let reviewState = true
      result.forEach(item => {
        if (item.verifyState === 0) {
          status = false
          return
        } else if (item.verifyState === 1) {
          // 复核通过/复核拒绝按钮是否禁用
          reviewState = false
          return
        }
      })
      this.$emit('refusePermission', status)
      this.$emit('reviewRefusePermission', reviewState)
    },
    onRowDoubleClicked(event) {
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    // 获取勾选的项目
    getSelections() {
      return getGridSelected(this.gridOptions)
    },
    updateListData(res) {
      this.rowData = res
    },
    // 自定义高级查询项
    getCustomSearchItems() {
      const dataProvider = this.isPretrialReview ? FbaJobConstants.VERIFY_STATES : FbaJobConstants.VERIFY_STATES_NEW
      const defaultSearchFields = []
      // 预审状态
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'fbaJob.VERIFY_STATE'
      searchField.itemLabel = 'FbaJob.VerifyState'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataCacheKey = 'local_cache_FbaJobConstants$VERIFY_STATES'
      searchField.dataCacheKey = ''
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = dataProvider
      defaultSearchFields.push(searchField.formatObj2Json())
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        const saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
          return mapping.statusEnabled === true && (mapping.fbaSea === true || mapping.fbaAir === true || mapping.fbaRailway === true)
        })
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      return defaultSearchFields
    },
    async initColumnDefs() {
      if (this.isZY) {
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(params.value)
            }
          }
        )
      }
    }
  }
}
</script>

<style lang="scss">
</style>
